var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 29.014,
    height: 32.754,
    viewBox: "0 0 29.014 32.754",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.302,
    y1: 0.298,
    x2: 0.81,
    y2: 0.84,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffcc41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8d1c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#ebeff2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 0.978,
    y1: 0.047,
    x2: 0.263,
    y2: 0.702,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 0.451,
    y1: -0.115,
    x2: 0.688,
    y2: 2.232,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#f36f56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 0.974,
    y1: -0.105,
    x2: 0.276,
    y2: 0.797,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#febd44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f99f4b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 0.593,
    y1: -0.143,
    x2: 0.053,
    y2: 3.782,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 0.5,
    x2: 0.886,
    y2: 0.818,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd188"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9e00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 0.575,
    y1: -0.146,
    x2: 0.374,
    y2: 1.521,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d8dee8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 0.576,
    y1: -0.503,
    x2: 0.164,
    y2: 5.397,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbb06f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 1.271,
    y1: -0.179,
    x2: -0.562,
    y2: 1.435,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8ac4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4392f7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "_12083507_Wavy_Bus-20_Single-10",
    "data-name": "12083507_Wavy_Bus-20_Single-10",
    transform: "translate(-589.179 -692.541)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustration",
    transform: "translate(589.179 692.541)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Business_analysis",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69497",
    "data-name": "Group 69497",
    transform: "translate(1.263 0.67)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69496",
    "data-name": "Group 69496"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69493",
    "data-name": "Group 69493"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58498",
    "data-name": "Path 58498",
    d: "M658.972,462.345l-16.579-.561a.656.656,0,0,0-.687.656v30.117a.639.639,0,0,0,.687.64l16.579-.943a.678.678,0,0,0,.62-.68V463.01A.659.659,0,0,0,658.972,462.345Z",
    transform: "translate(-641.706 -461.784)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_69492",
    "data-name": "Group 69492",
    transform: "translate(0)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58499",
    "data-name": "Path 58499",
    d: "M652.171,484.584c-.282-3.444,1.833-4.865,1.027-7.985-1-3.857-4.832-4.022-6.138-7.8-.5-1.449-.7-3.64.734-6.829l-5.4-.183a.656.656,0,0,0-.687.656v30.117a.639.639,0,0,0,.687.64l14.783-.841C653.416,489.444,652.344,486.7,652.171,484.584Z",
    transform: "translate(-641.707 -461.783)",
    fill: "#d8dee8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_69494",
    "data-name": "Group 69494",
    transform: "translate(3.645 23.715)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58501",
    "data-name": "Path 58501",
    d: "M962.476,2480.58l-10.06.363a.449.449,0,0,0-.43.445h0a.411.411,0,0,0,.43.413l10.06-.388a.43.43,0,0,0,.4-.431h0A.393.393,0,0,0,962.476,2480.58Z",
    transform: "translate(-951.986 -2480.58)",
    opacity: 0.6,
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58502",
    "data-name": "Path 58502",
    d: "M962.476,2606.885l-10.06.407a.452.452,0,0,0-.43.447h0a.409.409,0,0,0,.43.412l10.06-.433a.432.432,0,0,0,.4-.433h0A.391.391,0,0,0,962.476,2606.885Z",
    transform: "translate(-951.986 -2605.401)",
    opacity: 0.6,
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58503",
    "data-name": "Path 58503",
    d: "M962.476,2733.188l-10.06.452a.454.454,0,0,0-.43.449h0a.406.406,0,0,0,.43.409l10.06-.477a.435.435,0,0,0,.4-.435h0A.388.388,0,0,0,962.476,2733.188Z",
    transform: "translate(-951.986 -2730.22)",
    opacity: 0.6,
    fill: "url(#linear-gradient-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_69495",
    "data-name": "Group 69495",
    transform: "translate(3.645 2.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58504",
    "data-name": "Path 58504",
    d: "M957.259,632.419l-5.06-.143a.206.206,0,0,0-.213.207h0a.22.22,0,0,0,.213.218l5.06.137a.2.2,0,0,0,.207-.2h0A.215.215,0,0,0,957.259,632.419Z",
    transform: "translate(-951.986 -632.276)",
    opacity: 0.6,
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58505",
    "data-name": "Path 58505",
    d: "M957.259,696.856l-5.06-.132a.206.206,0,0,0-.213.207h0a.219.219,0,0,0,.213.218l5.06.126a.2.2,0,0,0,.207-.2h0A.215.215,0,0,0,957.259,696.856Z",
    transform: "translate(-951.986 -695.966)",
    opacity: 0.6,
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58506",
    "data-name": "Path 58506",
    d: "M957.259,761.293l-5.06-.121a.207.207,0,0,0-.213.208h0a.219.219,0,0,0,.213.217l5.06.115a.2.2,0,0,0,.207-.2h0A.214.214,0,0,0,957.259,761.293Z",
    transform: "translate(-951.986 -759.658)",
    opacity: 0.6,
    fill: "url(#linear-gradient-2)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_69511",
    "data-name": "Group 69511",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69508",
    "data-name": "Group 69508",
    transform: "translate(3.54)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69504",
    "data-name": "Group 69504"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69501",
    "data-name": "Group 69501"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69500",
    "data-name": "Group 69500",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58513",
    "data-name": "Path 58513",
    d: "M846.45,428.561c-.294-3.59,1.912-5.072,1.07-8.325-1.04-4.021-5.038-4.193-6.4-8.136-.522-1.511-.728-3.795.766-7.12l-5.63-.191a.684.684,0,0,0-.716.684v31.4a.666.666,0,0,0,.716.667l15.413-.876C847.748,433.628,846.63,430.768,846.45,428.561Z",
    transform: "translate(-835.54 -404.789)",
    fill: "#d8dee8"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_58514",
    "data-name": "Path 58514",
    d: "M889.073,440.826l-17.286-.565a.281.281,0,0,0-.294.281v31.364a.274.274,0,0,0,.294.274l17.286-.963a.291.291,0,0,0,.266-.291V441.111A.282.282,0,0,0,889.073,440.826Z",
    transform: "translate(-871.071 -439.844)",
    fill: "url(#linear-gradient-8)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_69502",
    "data-name": "Group 69502",
    transform: "translate(3.8 24.725)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58515",
    "data-name": "Path 58515",
    d: "M1169.982,2509.634l-10.489.378a.468.468,0,0,0-.449.464h0a.428.428,0,0,0,.449.43l10.489-.4a.448.448,0,0,0,.422-.45h0A.41.41,0,0,0,1169.982,2509.634Z",
    transform: "translate(-1159.045 -2509.634)",
    fill: "#d8dee8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58516",
    "data-name": "Path 58516",
    d: "M1169.982,2641.322l-10.489.425a.471.471,0,0,0-.449.466h0a.426.426,0,0,0,.449.429l10.489-.451a.45.45,0,0,0,.422-.452h0A.408.408,0,0,0,1169.982,2641.322Z",
    transform: "translate(-1159.045 -2639.775)",
    fill: "#d8dee8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58517",
    "data-name": "Path 58517",
    d: "M1169.982,2773.01l-10.489.471a.473.473,0,0,0-.449.468h0a.424.424,0,0,0,.449.427l10.489-.5a.453.453,0,0,0,.422-.453h0A.405.405,0,0,0,1169.982,2773.01Z",
    transform: "translate(-1159.045 -2769.916)",
    fill: "#d8dee8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_69503",
    "data-name": "Group 69503",
    transform: "translate(3.8 2.088)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58518",
    "data-name": "Path 58518",
    d: "M1164.543,582.7l-5.276-.149a.214.214,0,0,0-.222.215h0a.229.229,0,0,0,.222.228l5.276.143a.21.21,0,0,0,.215-.212h0A.224.224,0,0,0,1164.543,582.7Z",
    transform: "translate(-1159.045 -582.548)",
    fill: "#d8dee8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58519",
    "data-name": "Path 58519",
    d: "M1164.543,649.88l-5.276-.138a.215.215,0,0,0-.222.216h0a.229.229,0,0,0,.222.227l5.276.131a.21.21,0,0,0,.215-.213h0A.224.224,0,0,0,1164.543,649.88Z",
    transform: "translate(-1159.045 -648.953)",
    fill: "#d8dee8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58520",
    "data-name": "Path 58520",
    d: "M1164.543,717.065l-5.276-.126a.216.216,0,0,0-.222.216h0a.228.228,0,0,0,.222.227l5.276.12a.211.211,0,0,0,.215-.213h0A.223.223,0,0,0,1164.543,717.065Z",
    transform: "translate(-1159.045 -715.36)",
    fill: "#d8dee8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_69507",
    "data-name": "Group 69507",
    transform: "translate(3.781 5.642)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69505",
    "data-name": "Group 69505",
    transform: "translate(0 2.107)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58521",
    "data-name": "Path 58521",
    d: "M1199.607,1068.9a2.257,2.257,0,0,1,1.735-1.194l.052-3.2a5.418,5.418,0,0,0-4.812,3.268Z",
    transform: "translate(-1196.123 -1064.507)",
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58522",
    "data-name": "Path 58522",
    d: "M1407.845,1562.744a2.267,2.267,0,0,1-2.2,1.891,2.214,2.214,0,0,1-.919-.189l-1.678,2.759a5.313,5.313,0,0,0,2.6.62,5.451,5.451,0,0,0,5.293-4.963Z",
    transform: "translate(-1400.161 -1556.891)",
    fill: "#8ac4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58523",
    "data-name": "Path 58523",
    d: "M1159.806,1398.049l1.683-2.761a2.277,2.277,0,0,1-.831-1.766,2.315,2.315,0,0,1,.055-.5l-3.028-1.124a5.53,5.53,0,0,0-.246,1.635A5.459,5.459,0,0,0,1159.806,1398.049Z",
    transform: "translate(-1157.439 -1388.05)",
    fill: "#4392f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_69506",
    "data-name": "Group 69506",
    transform: "translate(5.819)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58524",
    "data-name": "Path 58524",
    d: "M1652.78,890.424a2.259,2.259,0,0,1,1.889,2.035l5.116.2v-.007a7.539,7.539,0,0,0-6.918-7.552Z",
    transform: "translate(-1652.78 -885.102)",
    fill: "url(#linear-gradient-10)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_69509",
    "data-name": "Group 69509",
    transform: "translate(0 5.161)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58526",
    "data-name": "Path 58526",
    d: "M542.888,848.053l-8.366-.083a.342.342,0,0,1-.343-.337v-3.182a.329.329,0,0,1,.343-.325l7.283.173a.333.333,0,0,1,.324.331v2.735Z",
    transform: "translate(-534.179 -844.126)",
    fill: "url(#linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58527",
    "data-name": "Path 58527",
    d: "M644.813,915.615l-5.54-.108v-.381l5.54.116Z",
    transform: "translate(-638.038 -914.292)",
    fill: "#fff",
    opacity: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58528",
    "data-name": "Path 58528",
    d: "M644.813,980.548l-5.54-.093v-.381l5.54.1Z",
    transform: "translate(-638.038 -978.477)",
    fill: "#fff",
    opacity: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58529",
    "data-name": "Path 58529",
    d: "M644.813,1045.48l-5.54-.078v-.381l5.54.085Z",
    transform: "translate(-638.038 -1042.661)",
    fill: "#fff",
    opacity: 0.67
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_69510",
    "data-name": "Group 69510",
    transform: "translate(12.086 17.506)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58530",
    "data-name": "Path 58530",
    d: "M1564.09,1895.869l10.06-.216a.47.47,0,0,1,.474.48v4.684a.5.5,0,0,1-.474.506l-10.6.358a.48.48,0,0,1-.5-.486v-6.122Z",
    transform: "translate(-1563.05 -1895.072)",
    opacity: 0.534,
    fill: "url(#linear-gradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58531",
    "data-name": "Path 58531",
    d: "M1715.477,2280.159l8.066-.241v.566l-8.066.251Z",
    transform: "translate(-1713.687 -2275.397)",
    fill: "#fff",
    opacity: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58532",
    "data-name": "Path 58532",
    d: "M1715.477,2183.758l8.066-.222v.566l-8.066.231Z",
    transform: "translate(-1713.687 -2180.147)",
    fill: "#fff",
    opacity: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58533",
    "data-name": "Path 58533",
    d: "M1715.477,2087.356l8.066-.2v.566l-8.066.212Z",
    transform: "translate(-1713.687 -2084.898)",
    fill: "#fff",
    opacity: 0.67
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_69518",
    "data-name": "Group 69518",
    transform: "translate(17.02 2.489)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69516",
    "data-name": "Group 69516"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58558",
    "data-name": "Path 58558",
    d: "M1983.039,679.4v5.919a.356.356,0,0,0,.355.356h11.331a.32.32,0,0,0,.309-.331v-5.507Z",
    transform: "translate(-1983.039 -678.665)",
    fill: "url(#linear-gradient-13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58559",
    "data-name": "Path 58559",
    d: "M1994.725,617.1l-11.331-.463a.339.339,0,0,0-.355.341v.607l11.995.423v-.564A.337.337,0,0,0,1994.725,617.1Z",
    transform: "translate(-1983.039 -616.64)",
    fill: "url(#linear-gradient-14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58560",
    "data-name": "Path 58560",
    d: "M2025.9,644.7a.15.15,0,0,1-.157.152.165.165,0,0,1-.157-.164.15.15,0,0,1,.157-.152A.165.165,0,0,1,2025.9,644.7Z",
    transform: "translate(-2025.083 -644.209)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_69517",
    "data-name": "Group 69517",
    transform: "translate(1.548 1.839)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58561",
    "data-name": "Path 58561",
    d: "M2115.723,777.59l-.889,0v-4.4l.889.027Z",
    transform: "translate(-2114.834 -773.183)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58562",
    "data-name": "Path 58562",
    d: "M2115.723,972.135l-.889,0v-2.09l.889.015Z",
    transform: "translate(-2114.834 -967.728)",
    fill: "url(#linear-gradient-15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58563",
    "data-name": "Path 58563",
    d: "M2220.755,780.744l-.876,0v-4.371l.876.026Z",
    transform: "translate(-2218.645 -776.332)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58564",
    "data-name": "Path 58564",
    d: "M2220.755,1061.177l-.876,0v-1.038l.876.009Z",
    transform: "translate(-2218.645 -1056.764)",
    fill: "url(#linear-gradient-15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58565",
    "data-name": "Path 58565",
    d: "M2324.278,783.854l-.863,0v-4.34l.863.026Z",
    transform: "translate(-2320.965 -779.436)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58566",
    "data-name": "Path 58566",
    d: "M2324.278,1103.439l-.863,0v-.541l.863.007Z",
    transform: "translate(-2320.965 -1099.021)",
    fill: "url(#linear-gradient-15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58567",
    "data-name": "Path 58567",
    d: "M2426.325,786.917l-.851,0V782.6l.851.026Z",
    transform: "translate(-2421.825 -782.494)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58568",
    "data-name": "Path 58568",
    d: "M2426.325,865.437l-.851,0v-3.375l.851.021Z",
    transform: "translate(-2421.825 -861.014)",
    fill: "url(#linear-gradient-15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58569",
    "data-name": "Path 58569",
    d: "M2526.927,789.939l-.839,0v-4.278l.839.025Z",
    transform: "translate(-2521.257 -785.51)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58570",
    "data-name": "Path 58570",
    d: "M2526.927,899.942l-.839,0v-2.971l.839.019Z",
    transform: "translate(-2521.257 -895.514)",
    fill: "url(#linear-gradient-15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58571",
    "data-name": "Path 58571",
    d: "M2626.115,792.918l-.827,0v-4.248l.827.025Z",
    transform: "translate(-2619.291 -788.484)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58572",
    "data-name": "Path 58572",
    d: "M2626.115,844.881l-.827,0v-3.63l.827.022Z",
    transform: "translate(-2619.291 -840.448)",
    fill: "url(#linear-gradient-15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58573",
    "data-name": "Path 58573",
    d: "M2723.917,795.855l-.816,0v-4.218l.816.025Z",
    transform: "translate(-2715.956 -791.416)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58574",
    "data-name": "Path 58574",
    d: "M2723.917,932.756l-.816,0v-2.591l.816.017Z",
    transform: "translate(-2715.956 -928.317)",
    fill: "url(#linear-gradient-15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58575",
    "data-name": "Path 58575",
    d: "M2820.364,798.751l-.8,0v-4.189l.8.024Z",
    transform: "translate(-2811.281 -794.307)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58576",
    "data-name": "Path 58576",
    d: "M2820.364,1028.824l-.8,0v-1.454l.8.011Z",
    transform: "translate(-2811.281 -1024.38)",
    fill: "url(#linear-gradient-15)"
  })))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_58577",
    "data-name": "Path 58577",
    d: "M885.568,464.038c-.294-3.637,1.911-5.138,1.07-8.434-1.039-4.073-5.037-4.248-6.4-8.242-.5-1.467-.71-3.655.59-6.8l-5.453-.181a.283.283,0,0,0-.294.285v31.772a.275.275,0,0,0,.294.278l14.942-.843C886.775,468.933,885.741,466.181,885.568,464.038Z",
    transform: "translate(-281.899 252.581)",
    fill: "#fff",
    opacity: 0.35,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.ce032db7f07c3b0485e3add8eea12144.svg";
export { ForwardRef as ReactComponent };